import type {Variants} from 'motion';

export const EnterFromZeroHeightAnimation: Variants = {
    enter: {height: 'auto'},
    exit: {height: 0},
    initial: {height: 0}
};